"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicStore = void 0;
class DynamicStore {
    constructor() {
        this._store = null;
    }
    getStore() {
        return this._store;
    }
    setStore(store) {
        this._store = store;
    }
}
exports.DynamicStore = DynamicStore;
//# sourceMappingURL=DynamicStore.js.map